import { navigate } from "svelte-routing";
import { get } from "svelte/store";
import { api } from "../../services/helpers";
import { getMasterData } from "../../services/profile";
import { carDetail, editBlackoutData, email as emailStore, errorMessage, loading, masterData, refreshToken, successMessage, token, userName, userRole, } from "../store";
export const doLogout = async () => {
    token.set("");
    refreshToken.set("");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userName");
    localStorage.removeItem("damageReviewedData");
    // Remove all caseInvestigate entries
    Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("caseInvestigate")) {
            localStorage.removeItem(key);
        }
    });
    carDetail.set("");
    masterData.set([]);
    userRole.set([]);
    editBlackoutData.set({
        id: "",
        stats: false,
    });
    navigate("/login");
};
export const doLogin = async ({ email, password }) => {
    try {
        let logToken;
        loading.set(true);
        errorMessage.set("");
        const res = await api("/v1/auth/login", "User", "POST", {
            email,
            password,
        });
        if (res.status === 200) {
            token.set(res.data.accessToken);
            logToken = get(token);
            userRole.set(res.data.profile.permissions);
            localStorage.setItem("userName", res.data.profile.firstName + " " + res.data.profile.lastName);
            userName.set(res.data.profile.firstName + " " + res.data.profile.lastName);
            emailStore.set(res.data.profile.email);
            loading.set(false);
            if (logToken) {
                localStorage.setItem("token", logToken);
                const resultMasterData = await getMasterData();
                masterData.set(resultMasterData.data);
                navigate("/dashboard");
            }
        }
        else {
            errorMessage.set(res.data.error_msg);
            loading.set(false);
        }
    }
    catch (err) {
        loading.set(false);
        if (err.response.data.code) {
            errorMessage.set(`Error ${err.response.data.code}: ${err.response.data.message}`);
        }
        else {
            errorMessage.set(err.message);
        }
    }
};
export const doForgot = async ({ email }) => {
    try {
        errorMessage.set("");
        loading.set(true);
        const res = await api("/v1/auth/forgot-password", "User", "POST", {
            email,
        });
        if (res.status === 200) {
            loading.set(false);
            successMessage.set("Please check your email for reset password link");
        }
        else {
            loading.set(false);
            errorMessage.set(res.data.errorMsg);
        }
    }
    catch (err) {
        loading.set(false);
        errorMessage.set(err.response.errors);
    }
};
export const doReset = async ({ testToken, password }) => {
    try {
        errorMessage.set("");
        loading.set(true);
        const res = await api("/v1/auth/reset-password", "User", "POST", {
            newPassword: password,
        }, {}, testToken);
        if (res.status === 200) {
            successMessage.set("Successfully reset password");
            errorMessage.set("");
            loading.set(false);
        }
        else {
            errorMessage.set(res.data.errorMsg);
            loading.set(false);
        }
    }
    catch (err) {
        errorMessage.set(err.response.errors);
        loading.set(false);
    }
};
export const rehydrateToken = () => {
    let logToken;
    let refToken;
    logToken = localStorage.getItem("token");
    refToken = localStorage.getItem("refreshToken");
    token.set(logToken);
    refreshToken.set(refToken);
};
